export default __webpack_public_path__ + "static/media/disc_2.7b0e116b.png";